module.exports = __webpack_public_path__ + "img/title-en.035d40bd.png";